import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/mavim.webp';
import screenshot_target from '../../../images/letterfunnel/jeanjacquesvossen.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Jean Jacques Vossen"
      firstname="Jean"
      companyname="Mavim"
      competition="SAP Signavio en ARIS"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/jeanjacquesvossen.js